module.exports = __webpack_public_path__ + "static/media/doctor-patient-consultation.eec75de2.jpg";